<template>
  <div>
    <voucher-steps :step="order.step" />

    <div class="container">
      <div class="header mb-3"></div>

      <div class="row">
        <div class="col-lg-4 col-12 order-sm-last">
          <div class="card card-sm" v-if="order.step === 1">
            <div class="card-body">
              <div class="row">
                <div class="col" v-if="data.products.length > 0">
                  <p>
                    Moveek vẫn chưa chính thức bán vé Lotte Cinema. Mời bạn mua voucher vé Lotte nhé.
                  </p>
                  <p>
                    <strong class="text-danger">{{ useFormatting().formatCurrency(data.products[0].price) }} cho mọi loại ghế 2D</strong> (bao gồm ghế VIP) trong
                    tất cả các ngày (bao gồm cuối tuần, lễ, Tết).
                  </p>
                  <p class="mb-0 text-center">
                    <a href="#" class="text-danger" data-toggle="modal" data-target="#voucherPolicyModal">Điều kiện sử dụng</a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="card d-none d-md-block">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted mb-2">
                    Tổng đơn hàng
                  </h6>
                  <span class="h2 mb-0">
                    {{ useFormatting().formatCurrency(order.amount.total) }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="card card-sm" v-if="order.step === 2">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <p class="mb-0">
                    Voucher đã mua không thể đổi hoặc hoàn tiền. Voucher sẽ được gửi 01 lần qua số điện thoại
                    và email đã nhập. Vui lòng kiểm tra lại thông tin trước khi tiếp tục.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="flow-actions sticky-footer-bars">
            <div class="row">
              <div class="col-3">
                <a href="#" class="btn btn-lg btn-outline-dark btn-block" :class="{ 'disabled' : order.step === 1 }" @click.prevent="stepHandler('prev')">
                  &larr;
                </a>
              </div>
              <div class="col-9">
                <a href="#" class="btn btn-lg btn-dark btn-block" :class="{ 'disabled': cart.products.length === 0 || order.processing }" @click.prevent="stepHandler('next')">
                  <span class="d-md-none">{{ useFormatting().formatCurrency(order.amount.total) }} |</span>
                  <span v-if="order.step !== 2">Tiếp tục</span>
                  <span v-else>{{ order.processing ? 'Đang xử lý...' : 'Xác nhận' }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-8 col-12">
          <div class="alert alert-danger" v-if="errors.length > 0">
            <p><strong>Có lỗi xảy ra:</strong></p>
            <ul>
              <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
            <p class="mb-0">
              Vui lòng thử lại hoặc <a href="/support" class="text-white">liên hệ trung tâm hỗ trợ</a>.
            </p>
          </div>

          <div v-if="errors.length === 0">
            <voucher-cart
                :products="data.products"
                :step="order.step"
                @product-pick="productPicker"
            />

            <voucher-checkout
                :cart="cart"
                :user="data.user"
                v-model:contact="order.contact"
                v-model:payment="order.payment"
                :amount="order.amount"
                :step="order.step"
                :completing="order.completing"
                :violations="order.violations"
                :errors="order.errors"
                @create:booking="createBooking"
                @open:modal="useBootstrap().openModal"
            />

          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="voucherPolicyModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="card mb-0">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col">
                  <h4 class="card-header-title">
                    Điều kiện sử dụng voucher vé xem phim
                  </h4>
                </div>
                <div class="col-auto">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <p>1. Vé áp dụng cho tất cả suất chiếu phim 2D vào tất cả các ngày trong tuần (bao gồm Lễ, Tết) tại hệ thống
                rạp Lotte Cinema trên toàn quốc. Ngoại trừ các suất chiếu đặc biệt theo quy định của nhà sản xuất hoặc nhà
                phát hành phim công bố tại từng thời điểm.</p>
              <p>2. Không áp dụng cho phim 3D và các phòng chiếu đặc biệt khác như Superplex, Cinecomfort, Charlotte...</p>
              <p>3. Khách hàng sẽ nhận được 01 mã đổi vé xem phim điện tử trên toàn hệ thống Lotte Cinema.</p>
              <p>4. Mỗi Mã phiếu đổi vé xem phim điện tử có thể quy đổi thành 01 vé xem phim 2D - cho loại ghế Thường hoặc VIP tại quầy vé.</p>
              <p>5. Một khách hàng được mua nhiều voucher</p>
              <p>6. E-Voucher/E-Coupon không có giá trị quy đổi thành tiền mặt, không trả lại tiền thừa, không được hoàn hủy.</p>
              <p>7. Không áp dụng đồng thời với chương trình khuyến mại khác.</p>
              <p>8. Vé được cung cấp dưới dạng mã code.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, inject, onBeforeMount } from 'vue'
import { useFormatting } from '../composables/formatting';
import { useBootstrap } from '../composables/bootstrap';
import axios from 'axios'
import { bindStickyBar } from '../dependencies/sticky-bar'

import VoucherSteps from './VoucherSteps.vue';
import VoucherCart from './VoucherCart.vue';
import VoucherCheckout from './VoucherCheckout.vue';

const props = defineProps({
  cineplex: {
    type: String,
    required: true
  },
  user: {
    type: String,
    required: true
  }
})

const root = inject('root')
const data = ref({
  cineplex: {
    id: 18785,
    name: 'Lotte Cinema'
  },
  products: [],
  user: {
    id: null,
    authenticated: false,
    balance: 0
  }
})
const cart = ref({
  products: [],
  creditPayable: false,
  checkout: false,
  contact: {}
})
const order = ref({
  status: 'pending',

  id: null,
  step: 1,
  contact: {
    name: null,
    phone: null,
    email: null,
  },
  payment: {
    gateway: 'moveek',
    method: 'bank-transfer'
  },
  amount: {
    subtotal: 0,
    total: 0,
    discount: 0,
    fee: 0,
  },
  processing: false,
  completing: false,
  reload: false,
  violations: [],
  errors: [],
})
const errors = ref([])

const stepHandler = (action) => {
  if (action === 'next') {
    if (order.value.step < 2) {
      order.value.step++
      cart.value.checkout = false
    } else {
      cart.value.checkout = true
      createOrder()
    }
  } else {
    if (order.value.step > 0) {
      order.value.step--
    }
  }
}

const getProduct = async () => {
  try {
    const response = await axios.get(`/voucher/${props.cineplex}/products`)
    data.value.products = response.data.map(item => ({
      ...item,
      quantity: 0
    }))
  } catch (error) {
    errors.value.push('Không tải được dữ liệu sản phẩm do có lỗi từ hệ thống đối tác')
  }
}

const getCustomer = () => {
  if (order.value.reload) {
    return
  }

  try {
    const customer = root.getCookie().get('mvtix_customer')
    if (customer) {
      const parsed = JSON.parse(customer)
      order.value.contact.name = parsed?.name
      order.value.contact.phone = parsed?.phone
      order.value.contact.email = parsed?.email
    }
  } catch (e) {
  }
}

const saveCustomer = () => {
  if (order.value.reload) {
    return
  }

  const customer = {
    name: order.value.contact.name,
    email: order.value.contact.email,
    phone: order.value.contact.phone
  }
  root.getCookie().set('mvtix_customer', customer, { expires: 365 })
}

const getUser = () => {
  data.value.user = JSON.parse(props.user)
}

const createOrder = async () => {
  if (order.value.processing === false) {
    order.value.processing = true

    const payload = {
      products: [],
      contact: order.value.contact,
    }

    cart.value.products.forEach(product => {
      if (product.quantity > 0) {
        payload.products.push({
          id: product.id,
          name: product.name,
          price: product.price,
          quantity: product.quantity
        })
      }
    })

    try {
      const response = await axios.post(`/voucher/${props.cineplex}/orders`, payload)
      order.value.id = response.data.id
      order.value.status = response.data.status

      // save customer
      saveCustomer()

      // show order confirmation modal
      useBootstrap().openModal('orderConfirmationModal')
    } catch (error) {
      const response = error?.response
      // handle validation
      if (response?.status === 400 && Array.isArray(response.data.violations)) {
        response.data.violations.forEach(v => {
          // turn "[contact][name]" into "contact.name"
          const key = v.propertyPath
              .replace(/\[(\w+)]/g, '.$1')
              .replace(/^\./, '')
          order.value.violations[key] = v.title
        })
      } else {
        console.log(error)
        alert('Không thể tạo đơn hàng do lỗi chưa xác định. Vui lòng thử lại sau.')
      }
    }
  }

  order.value.processing = false
}

const createBooking = async () => {
  if (order.value.completing === false) {
    order.value.completing = true

    // clear old errors
    order.value.errors = []

    // create booking
    try {
      const payload = {
        status: 'awaiting_payment',
        payment_gateway: order.value.payment.gateway,
        payment_method: order.value.payment.method,
      }
      const response = await axios.patch(`/voucher/orders/${order.value.id}`, payload)

      window.location = response.data.redirect_url
    } catch (error) {
      const response = error?.response
      if (response?.status === 403) {
        order.value.errors.push('Đơn hàng này đã được thanh toán hoặc đã hết hạn. Vui lòng <a href="/mua-voucher/lotte-cinema" class="text-white-50">thử lại</a> hoặc <a href="/support" class="text-white-50">liên hệ trung tâm hỗ trợ</a>.')
      } else if (response?.status === 400 && Array.isArray(response.data.violations)) {
        response.data.violations.forEach(v => {
          // turn "[contact][name]" into "contact.name"
          const key = v.propertyPath
              .replace(/\[(\w+)]/g, '.$1')
              .replace(/^\./, '')
          order.value.errors.push(key +': ' + v.title)
        })
      }
      else {
        alert('Không thể tạo đơn hàng do lỗi chưa xác định. Vui lòng thử lại sau.')
      }

      order.value.completing = false
    }
  }
}

const productPicker = (product, action, quantity = 1) => {
  if (action === 'add') {
    product.quantity = product.quantity + quantity
  } else {
    product.quantity = product.quantity - quantity
  }

  const index = getPickedProductIndex(product)
  if (index === null && product.quantity > 0) {
    cart.value.products.push(product)
  }

  if (index !== null && product.quantity === 0) {
    cart.value.products.splice(index, 1)
  }
}

const getPickedProductIndex = (product) => {
  let index = null
  cart.value.products.forEach((c, i) => {
    if (c.id === product.id) {
      index = i
    }
  })
  return index
}

const calculateCartTotal = () => {
  let total = 0
  cart.value.products.forEach(product => {
    total += product.price * product.quantity
  })
  order.value.amount.total = total
}

// watch cart changes
watch(cart, () => {
  calculateCartTotal()
  cart.value.creditPayable = data.value.user.balance >= order.value.amount.total
}, { deep: true })

// initialize
onMounted(() => {
  getProduct()
  getCustomer()
  setTimeout(() => {
    bindStickyBar()
  }, 500)
})

onBeforeMount(() => {
  getUser()
})

</script>